/**
 * Helpers de "document model" compartilhados pelos 5 `sections/documentModel.js`
 * do Easy Solutions. Espelham a mesma lógica usada pelo `renderQuestion()` /
 * `renderImages()` de cada `Content.js` (PDF), para que o modelo de blocos
 * (consumido pelo `_shared/generateDocx.js`) não divirja do que o PDF mostra.
 *
 * Importante: isto NÃO substitui os `Content.js` existentes (o caminho PDF via
 * print-js continua exatamente como está) — só extrai, para o DOCX, os mesmos
 * dados já carregados por `ServiceOrderLoader`/`pdfHelpers.js`.
 */

export const getQuestionDisplayValue = question => {
  if (Array.isArray(question?.value)) return ''
  if (typeof question?.value === 'boolean') return question.value ? 'Sim' : 'Não'
  return question?.value ?? 'N/A'
}

export const getQuestionFiles = question => {
  const isArray = Array.isArray(question?.value)
  return (isArray ? question?.value : question?.documents) ?? []
}

export const toImages = files => (files || []).filter(file => file?.src).map(file => ({ src: file.src, description: file.description }))

/**
 * Mesma regra de `Content.js#renderQuestion()`: um bloco `keyValue` com o
 * nome da pergunta + valor, seguido (se houver arquivos) de um `imageGrid`.
 */
export const questionBlocks = question => {
  if (!question?.question?.name) return []
  const blocks = [{ type: 'keyValue', label: question.question.name, value: getQuestionDisplayValue(question) }]
  const files = toImages(getQuestionFiles(question))
  if (files.length > 0) blocks.push({ type: 'imageGrid', images: files })
  return blocks
}

/** Bloco de imagens a partir de uma lista de `documents` (sem o texto do keyValue). */
export const imageGridBlocks = documents => {
  const images = toImages(documents)
  return images.length > 0 ? [{ type: 'imageGrid', images }] : []
}
